import { http, lHttp } from '@utils/interceptor'
import { round, toNumber, map, join, toArray, isEmpty, intersectionWith, toPlainObject, uniq, includes, filter, flatMap, takeWhile, isArray, uniqWith, multiply } from 'lodash'
import { ActionContext, Module } from 'vuex'
import axios from 'axios'
import { uid, getSelectedCityId, mapCategorys } from '@utils/index'

import { RoleType, CARESSTUINA } from '@constant/index'

import { SVSESQUERYALLDATA } from '@constant/api'

const api = {
  cms: '//soperationapi.czj100.com/soperation-api/ads/queryAdvertisements.do',
  getDistrictList: '//address.cekid.com/addressview/GetDistrictList',
  queryCategorys: '//sccapi.czj100.com/scc-api/fchild/applyJoin/queryCategorys.do',
  queryCityAndLevel4CategorySpus: '//sccapi.czj100.com/scc-api/fchild/worker/queryCityAndLevel4CategorySpus.do',
  queryCategoryBusinessAndSpuList: '//scbapi.czj100.com/scb-api/business/queryCategoryBusinessAndSpuList.do',
  queryStoreWorker: '//sccapi.czj100.com/scc-api/fchild/worker/queryStoreWorker.do',
  queryKidsStoreList: '//scbapi.czj100.com/scb-api/store/queryKidsStoreList.do',
  queryHzwNearStoreWorker: '//scbapi.czj100.com/scb-api/appStore/queryHzwNearStoreWorker.do',
  grayscale: '//cms.cekid.com/publish/999/h5-category-grayscale.json',
  queryCmmty: '//svsesapi.haiziwang.com/svses-api/api/queryCmmty.do', //搜索联营数据
  querySelfCmmty: '//svsesapi.haiziwang.com/svses-api/api/querySelfCmmty.do' //搜索自营数据
}

export async function queryItem(level4CategoryId: string[]) {
  const cityId = getSelectedCityId(false)
}

export async function getCMS(par: any): Promise<any> {
  const res = http.get(api.cms, {
    params: par
  })
  return res
}

export async function getDistrictList(): Promise<any> {
  const cityId = getSelectedCityId(false)
  return http.get(api.getDistrictList, {
    params: {
      cityId
    }
  })
}
/**
 * 搜索查区
 */
export async function getSeekDistrictList(level4CategoryIdArr: string[] = []): Promise<any> {
  const cityId = getSelectedCityId(false)
  return http.post(SVSESQUERYALLDATA, {
    fls: 'id',
    filter: { cityIds: cityId, level4CategoryId: level4CategoryIdArr, isSelf: 2, isSpec: 0 },
    collapse: 'storeDistrictId',
    collapseFls: 'storeDistrictId,storeDistrictName,realTotal'
  })
}
/**
 * 搜索查项目类型
 */
export async function getItemTypeList(level4CategoryIdArr: string[] = []): Promise<any> {
  const cityId = getSelectedCityId(false)
  return http.post(SVSESQUERYALLDATA, {
    fls: 'id',
    filter: { cityIds: cityId, level4CategoryId: level4CategoryIdArr, isSelf: 2, isSpec: 0 },
    collapse: 'spuId',
    collapseFls: 'itemType1,itemType2,realTotal'
  })
}
export interface ParamsSpu {
  districtId?: string //区域编码
  level4CategoryIds?: string[] //四级品类编码
  pageIndex?: number //页码
  pageSize?: number //每页显示数量
  isSelf?: number //是否是孩子王自营 1是 0否
  sort?: number //排序值（1-服务次数最多 4-价格最高 5-价格最低），默认1
  longLatitude?: string //经纬度，维度在前，经度在后，若存在则必填
}

/**
 * 搜索-自营商品数据
 * @param params
 */
export async function querySelfCmmty(params: ParamsSpu): Promise<any> {
  const cityId = getSelectedCityId(false)
  const { longLatitude, level4CategoryIds: level4CategoryId } = params
  return lHttp.post(api.querySelfCmmty, {
    cityId,
    level4CategoryId,
    longLatitude,
    start: 0,
    limit: 99
  })
}

export async function queryCityAndLevel4CategorySpus(params: ParamsSpu): Promise<any> {
  const cityId = getSelectedCityId(false) //城市编码
  const level4CategoryId = join(params.level4CategoryIds, ',') //多个用英文逗号隔开
  return lHttp.get(api.queryCityAndLevel4CategorySpus, {
    params: { ...params, cityId, level4CategoryId, uid }
  })
}

export interface ParamsBusiness {
  districtId?: string //区域编码
  level4CategoryIds?: string[] //四级品类编码
  pageIndex: number //页码
  pageSize?: number //每页显示数量
  other?: string //其他 distance --距离
  lng: number //经度
  lat: number // 纬度
  allCategoryIds?: any[] //全部品类
  isSelectBusiness: boolean //是否选择商户
  isSelectSpu: boolean //是否选择商品
  isSelectSaleNum: boolean //是否选择销量
  isSelectNearest: boolean //是否选择最近距离
  isStoreFavCommentNum: boolean //是否选择好评
  limit: number //分页end 必填，单页查询该值最大为100
  start: number //分页start， 必填
  isTentant: boolean // 是否是商户
  itemType1: string //项目类型1
  itemType2: string //项目类型2
}
/**
 * 商户/商品--搜索
 * @param params
 */
export async function queryCmmty(params: ParamsBusiness, showLoading = false): Promise<any> {
  const cityId = getSelectedCityId(false) //城市编码
  const { lat, lng, pageIndex, pageSize, districtId, level4CategoryIds, isTentant = true, other, itemType1 = '', itemType2 = '' } = params
  const start = multiply(pageIndex - 1, pageSize || 10)
  const isSelectNearest = other === 'distance'
  const isSelectSaleNum = other === 'sales'
  const isStoreFavCommentNum = other === 'star'
  const isSelectBusiness = isTentant
  const isSelectSpu = !isTentant
  const longLatitude = lat && lng ? `${lat},${lng}` : ''
  const level4CategoryId = level4CategoryIds
  const selectDistrictId = !!districtId ? +districtId : 0

  const query = itemType1 ? JSON.stringify({ itemType1 }) : itemType2 ? JSON.stringify({ itemType2 }) : undefined

  const request = showLoading ? lHttp : http
  return request.post(api.queryCmmty, {
    start,
    limit: pageSize || 10,
    selectDistrictId,
    cityId,
    level4CategoryId,
    isSelectBusiness,
    isSelectSpu,
    isSelectNearest: !!longLatitude ? isSelectNearest : false,
    isSelectSaleNum,
    isStoreFavCommentNum,
    longLatitude,
    isSpec: 0,
    query
  })
}

export async function queryBusinessAndSpuList(params: ParamsBusiness): Promise<any> {
  const cityId = getSelectedCityId(false) //城市编码
  const { pageIndex, pageSize, districtId, allCategoryIds: allList } = params
  const { lng: longitude, lat: latitude } = params
  const categoryIds = join(params.level4CategoryIds, ',') //多个用英文逗号隔开
  const nearest = params.other === 'distance' ? 0 : 1
  const allCategoryIds = join(allList, ',') || ''
  const { code, msg, data = {} } = await http.get(api.queryCategoryBusinessAndSpuList, {
    params: {
      uid,
      pageIndex,
      pageSize,
      districtId,
      cityId,
      categoryIds,
      allCategoryIds,
      nearest,
      longitude,
      latitude
    }
  })

  return {
    code,
    msg,
    data: data.data,
    cityHasBusiness: data.cityHasBusiness
  }
}

export async function queryConsultantList(param: any) {
  param = isEmpty(param) ? {} : param
  const cityId = getSelectedCityId(false) //城市编码
  if (param.spuId) {
    param.spuId = uniq(param.spuId)
  }
  const params = { ...param, userTypes: [RoleType.consultant], cityId }
  return http.get(api.queryStoreWorker, {
    params: {
      param: JSON.stringify(params)
    }
  })
}

export async function queryStoreofActivityList(spuIdListString: string | undefined) {
  const cityId = getSelectedCityId(false) //城市编码
  const spuIdList = spuIdListString ? JSON.stringify(spuIdListString.split(',')) : ''
  return http.get(api.queryKidsStoreList, {
    params: {
      spuIdList,
      cityId
    }
  })
}

async function queryHzwNearStoreWorker(position: any, spuIdList: string[] = []) {
  if (!position) {
    return null
  }
  const cityId = getSelectedCityId(false) //城市编码
  const response: ResponseCode = await http.get(api.queryHzwNearStoreWorker, {
    params: {
      longitude: position.lng,
      latitude: position.lat,
      cityId,
      spuIdList: JSON.stringify(spuIdList)
    }
  })
  if (response && response.code == '1' && response.data && response.data.data) {
    return toPlainObject(response.data.data)
  } else {
    return null
  }
}

export async function getSelfOperatedData(position: any, arr: any[]) {
  const params: ParamsSpu = {
    pageIndex: 1,
    pageSize: 99,
    isSelf: 1
  }
  const requestList: any[] = map(arr, async (item: any) => {
    const level4CategoryIds = [item]
    const response: ResponseCode = await queryCityAndLevel4CategorySpus({
      ...params,
      level4CategoryIds
    })
    if (response && response.code == '1') {
      return toArray(response.data)
    } else {
      return null
    }
  })
  return new Promise((resolve: (v: any) => void) => {
    axios.all(requestList).then(
      axios.spread((...args: any[]) => {
        const data: any = {
          spuList: [],
          nearStore: null,
          worker: []
        }
        const spuList = filter(args, (o: any) => {
          return o && o.length > 0
        })
        data.spuList = spuList
        const spuId = flatMap(spuList, (item: any) => map(item, (o: any) => o.spuId))
        if (spuId && spuId.length > 0) {
          queryHzwNearStoreWorker(position, spuId).then(result => {
            if (result) {
              data.worker = result.workerList
              const { distance, storeCode, storeName, addressDistrict } = result
              data.nearStore = {
                distance,
                storeCode,
                storeName,
                addressDistrict
              }
            }
            resolve(data)
          })
        } else {
          resolve(data)
        }
      })
    )
  })
}

export interface CategoryState {
  categoryList: any[]
  nearbyStore: any
  consultantList: any[]
  selfOperatedData: any
  grayscale: any
  cmsData: any
  itemTypeList: any
}

export const STORE: Module<CategoryState, any> = {
  namespaced: true,
  state: () => ({
    categoryList: [],
    nearbyStore: null,
    consultantList: [],
    selfOperatedData: null,
    grayscale: null,
    cmsData: null,
    itemTypeList: []
  }),
  mutations: {
    setCategorys(state: CategoryState, payload: any) {
      state.categoryList = payload
    },
    setNearbyStore(state: CategoryState, payload: any) {
      state.nearbyStore = payload
    },
    setConsultantList(state: CategoryState, payload: any) {
      state.consultantList = payload
    },
    setSelfOperatedData(state: CategoryState, payload: any) {
      state.selfOperatedData = payload
    },
    setGrayscale(state: CategoryState, payload: any) {
      state.grayscale = payload
    },
    setCMSData(state: CategoryState, payload: any) {
      state.cmsData = payload
    },
    setItemTypeList(state: CategoryState, payload: any) {
      state.itemTypeList = payload
    }
  },
  getters: {},
  actions: {
    async getCategorylist(context: ActionContext<CategoryState, any>, categoryIds: string[] | undefined) {
      const allCategoryList = await context.dispatch('getAllCategorylist', null, { root: true })
      if (allCategoryList && allCategoryList.length > 0) {
        const list = intersectionWith(allCategoryList, categoryIds || [], (item: any, categoryId: string) => item.value == categoryId)
        context.commit('setCategorys', list)
        return list
      }
      context.commit('setCategorys', [])
      return []
    },
    async getSelfOperatedData(context: ActionContext<CategoryState, any>, payload: any) {
      const { categoryId, positon } = payload
      const categoryHasIds = includes(CARESSTUINA, categoryId)
      const categoryList = categoryHasIds ? CARESSTUINA : [categoryId]
      const response = await getSelfOperatedData(positon, categoryList)
      context.commit('setSelfOperatedData', response)
      return response
    },
    async getSelfOperatedDataGrayscale(context: ActionContext<CategoryState, any>, payload: any) {
      const { categoryId, positon } = payload
      const categoryHasIds = includes(CARESSTUINA, categoryId)
      const categoryList = categoryHasIds ? CARESSTUINA : isArray(categoryId) ? categoryId : [categoryId]
      const lng = positon?.lng
      const lat = positon?.lat
      const longLatitude = lat && lng ? `${lat},${lng}` : ''
      const response: ResponseCode = await querySelfCmmty({ longLatitude, level4CategoryIds: categoryList })
      if (response && response.code == 1) {
        const selfInfo = response?.data?.selfInfo
        if (selfInfo) {
          const { distance, storeDistrictName, storeId, storeName, spuInfo, spuWorkers: worker } = selfInfo
          const spuList = uniqWith(spuInfo, (value: any, other: any) => {
            return value.spuId === other.spuId
          })
          const selfOperatedData = {
            nearStore: {
              distance,
              storeDistrictName,
              storeId,
              storeName
            },
            worker,
            spuList
          }
          context.commit('setSelfOperatedData', selfOperatedData)
          return selfOperatedData
        }
        context.commit('setSelfOperatedData', null)
      } else {
        context.commit('setSelfOperatedData', null)
      }
      return null
    },
    async getGrayscale(context: ActionContext<CategoryState, any>, payload: any) {
      const response: ResponseCode = await lHttp.get(api.grayscale)
      if (response && response.code == 0 && response.data) {
        context.commit('setGrayscale', toArray(response.data.category))
        context.commit('setItemTypeList', toArray(response.data.itemTypeList))
        return response.data.category
      } else {
        return null
      }
    },
    async getCMSAction(context: ActionContext<CategoryState, any>, par: any) {
      const res: ResponseCode = await getCMS(par)

      const _t = res.data['1_103']
      context.commit('setCMSData', _t)
    }
  }
}
